<app-report-new-report  [ReportMainData]="ReportMainData"></app-report-new-report>